import React from "react";
import { Navigate } from "react-router-dom"; // You can use 'Navigate' from react-router-dom to redirect

// ProtectedRoute component
const ProtectedRoute = ({ children }) => {
  // Check if auth_code exists in sessionStorage (you can change this depending on where you store your token)
  const authCode = sessionStorage.getItem("auth_code");

  if (!authCode) {
    // If no auth_code is found, redirect to login page
    return <Navigate to="/" replace />;
  }

  // If auth_code exists, render the protected component
  return children;
};

export default ProtectedRoute;
